"use client";

import React from "react";
import { useEvents, type ChannelEventHandler } from "./pusher";

interface Props {
  children: React.ReactNode;
}

const WorkplaceProvider: React.FC<Props> = ({ children }) => {
  useEvents(
    React.useMemo(() => {
      const onWorkflowUpdated: ChannelEventHandler = (data) => {
        try {
          window.dispatchEvent(
            new CustomEvent("workflow.updated", { detail: data }),
          );
        } catch {
          // ignore broadcast errors
        }
      };

      return [
        {
          channel: ({ subdomain }: { subdomain?: string | null }) =>
            subdomain ? `private-${subdomain}` : "",
          events: {
            "workflow.updated": onWorkflowUpdated,
          },
        },
      ];
    }, []),
  );

  return <>{children}</>;
};

export default WorkplaceProvider;
